import angular from 'angular';
import ngMessages from 'angular-messages';
import SearchContainer from './search/search.component';
import ResultsContainer from './results/results.component';
import ExpertContainer from './expert/expert.component';
import ExpertContactContainer from './expert-contact/expert-contact.component';
import ErrorContainer from './error/error.component';

const ContainerModule = angular
  .module('containers.expertFinder', [
    ngMessages
  ])
  .component('searchContainer', SearchContainer)
  .component('resultsContainer', ResultsContainer)
  .component('expertContainer', ExpertContainer)
  .component('expertContactContainer', ExpertContactContainer)
  .component('errorContainer', ErrorContainer);

export default ContainerModule;



// WEBPACK FOOTER //
// ./src/containers/index.js